import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import { toast } from 'react-toastify';
import { Typeahead } from 'react-bootstrap-typeahead';
import { useState } from 'react';

function Student_Manage_Modal({majors, cohorts, supervisors,  major, setMajor, cohort, setCohort, supervisor, setSupervisor, isOpen, setIsAdd, add, studentId, edit, token, studentName, setStudentName, studentEmail, setStudentEmail, studentCode, setStudentCode }) {
  const [loading, setLoading] = useState(false);


  const handleStudentNameChange = (e) => setStudentName(e.target.value)
  const handleStudentEmailChange = (e) => setStudentEmail(e.target.value)
  const handleStudentCodeChange = (e) => setStudentCode(e.target.value)
  const onSubmit = async () => {
    
    if (loading) return;
    setLoading(true)

    let result

    try {

      if (studentName == '') {
        toast.error('Failed, Student name is empty!')
        return
      }
      if (studentEmail == '') {
        toast.error('Failed, Student email is empty!')
        return
      }
      if (studentCode == '') {
        toast.error('Failed, Student code is empty!')
        return
      }
      if (studentId == -1){
        const payload = {
          name: studentName,
          email: studentEmail,
          code: studentCode,
          image: 'a',
          attendId: -1,
          majors: [major?.[0]?.id??''],
          cohorts: [cohort?.[0]?.id??''],
          supervisors: [supervisor?.[0]?.id??''],
          roles: ["student"]
        }
        
        result = await add(payload, token)
      }
      else{
        const payload = {
          name: studentName,
          majors: major?.[0]?.id??'',
          cohorts: cohort?.[0]?.id??'',
          supervisors: supervisor?.[0]?.id??'',
          email: studentEmail,
          code: studentCode,
        }
        result = await edit(payload, studentId, token)
      }
      if (result?.status == 200 || result?.status == 201) {
        let msg = studentId == -1 ? 'Student added successfully' : 'Student edited successfully'
        toast.success(msg)
        // disappear modal
        setIsAdd(false)
      }
    } catch (error) {
      const errmsg = error.response?.data?.message
      if (!errmsg)
        return

      // show error reason as an error toast 
      if (Array.isArray(errmsg)) {

        errmsg.forEach((element, index) => {
          setTimeout(function () {
            toast.error(element)
          }, 200 * index);
        });
      } else {
        toast.error(errmsg)
      }

    }finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      show={isOpen}
      // setIsAdd={setIsAdd}
      onHide={
        function () { setIsAdd(false) }
      }
      centered
    >
      <Modal.Header closeButton  >
        <Modal.Title>{studentId == -1 ? 'Add new student' : 'Edit student'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group onSubmit={onSubmit} >
          <Form.Label>Student name: </Form.Label>
          <Form.Control type="text" onChange={handleStudentNameChange} value={studentName} placeholder="Enter student name.." />
          <br />
          <Form.Label>Student email: </Form.Label>
          <Form.Control type="text" onChange={handleStudentEmailChange} value={studentEmail} placeholder="Enter student email.." />
          <br />
          <Form.Label>Student code: </Form.Label>
          <Form.Control type="text" onChange={handleStudentCodeChange} value={studentCode} placeholder="Enter student code.." />
      

        </Form.Group>
        <Form.Group>
          <Form.Label>Major: </Form.Label>
          <Typeahead
            id="major-selection"
            labelKey="name"
            onChange={setMajor}
            options={majors?.data??[]}
            placeholder={`Choose a major...`}
            selected={major}
          />
        </Form.Group>

        <Form.Group>
          <Form.Label>Cohort: </Form.Label>
          <Typeahead
            id="cohort-selection"
            labelKey="name"
            onChange={setCohort}
            options={cohorts.data}
            placeholder={`Choose a cohort...`}
            selected={cohort}
          />
        </Form.Group>

        <Form.Group>
          <Form.Label>Supervisor:  <small style={{color:'red', fontSize: 12}}>Will delete all the attends! </small></Form.Label>
          <Typeahead
            id="supervisor-selection"
            labelKey="name"
            onChange={setSupervisor}
            options={supervisors.data}
            placeholder={`Choose a supervisor...`}
            selected={supervisor}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button disabled={loading} variant="primary" type="submit" onClick={() => {
          // this.props.isOpen = false;
          // return handleSubmit(name)
          // return;
          onSubmit()
        }}>
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default Student_Manage_Modal;